import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class APIKeyService {
  baseUrl: string = environment.API_SERVER;
  constructor(private _http: HttpClient) {}

  getApiKeys(payload) {
    return this._http.get(
      `${this.baseUrl}/organizations/${payload.organizationId}/api_keys/`,
      {
        params: payload.params,
      }
    );
  }

  deleteApiKey(payload) {
    return this._http.delete(
      `${this.baseUrl}/organizations/${payload.organizationId}/api_keys/?api_key=${payload.apiKey}`
    );
  }

  generateApiKey(payload) {
    return this._http.post(
      `${this.baseUrl}/users/${payload.appUserId}/api_key/?applicationId=${payload.applicationId}`,
      payload.body
    );
  }
}
